<template>
  <main-layout>
	<section role="main" aria-label="תוכן" class="content" id="RhythmAudition">
			<div class="divider"></div>
			<div class="info-content">
				<div class="fill">
					<img :key=img2srcD src="photos/rhythm/pic01.jpg" alt="איך מצטרפים?" class="fillImgFront" >
				</div>
				<div class="textbox-bounds textbox-bounds-unbound-double">
						<div class="textbox-tab-mark""></div>
<div id="origamiform" data-origamiformname="form_60535b7a703b5" data-origamiformid="7f13ea0dcf451dcaaa3a1302797f1cf73571e4fd4c3dbd53097cba8fc7bd5557d48ab4a8aabbd10df91b7f5f9ab46b85d53f3df28bd8c1a66432f41c980e4c02Bo4z7mwvaX+7php4gfaAkz/HS12o6SAabt95wTMplVjY5gr3a1ABECPM4sPNnhxvF6RL1ObY8dTMLHLDXRMNv81yi9qaDJ/4B24mw5S92M5R9HS1LIFLysWJ5S9QfypW" ></div>
						<div class="textbox-text">
							
						</div>
					
				</div>
			</div>
			<br>
			<div id="FAQSdivider" class="divider"></div>
			
		</section>
  </main-layout>
</template>
<script>
var APIbase = "https://yard-bands.herokuapp.com"
import axios from 'axios'
  import MainLayout from '../layouts/Origami.vue'
   import VLink from '../components/VLink.vue'
  import VueScrollTo from 'vue-scrollto'

/* eslint-disable no-useless-escape */
import postscribe from 'postscribe'

  export default {
  mounted:function(){
    postscribe('#origamiform', '<script src="https://public.origamicloud.ms/web_forms/js"><\/script>')
	postscribe('#origamiform', '<script type="text/javascript"> ORIGAMI_FORMS["form_60535b7a703b5"] = { "fields": { "Lead_First_name" : { "value" : "testing", "hidden" : true }, }, "rtl": "1" };  <\/script>')
  },
    components: {
      MainLayout,VLink
    },
	created () {
		this.texts = {}
	},
	ready:function(){
    },
	data() {
		return {
		}
	},
	watch: {

		
	},
	methods: {
		scrollToFooter(){
			this.$scrollTo(".credits", 0, {})
		}
	}

  }
</script>



// WEBPACK FOOTER //
// EnsambleManual.vue?7b97d86e